export default class OrderSyncManager {
  constructor() {
    this.csrfToken = $('meta[name="csrf-token"]').attr('content');
  }

  syncOrders(syncUrl, orderIds) {
    return $.ajax({
      url: syncUrl,
      method: 'POST',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      data: JSON.stringify({ order_ids: orderIds }),
      contentType: 'application/json'
    }).then(
      (data, _status, xhr) => this.normalizeSyncResponse(data, xhr, orderIds),
      (xhr) => {
        const normalized = this.normalizeSyncResponse(null, xhr, orderIds);
        if (normalized && normalized.success) {
          return normalized;
        }
        return $.Deferred().reject(xhr, 'error', normalized.error).promise();
      }
    );
  }

  normalizeSyncResponse(data, xhr, orderIds) {
    if (data && typeof data === 'object') {
      return data;
    }

    if (xhr && xhr.status === 204) {
      return this.buildFallbackResponse(orderIds);
    }

    if (xhr && xhr.status >= 200 && xhr.status < 300) {
      return this.buildFallbackResponse(orderIds);
    }

    if (typeof data === 'string' && data.trim().length) {
      try {
        return JSON.parse(data);
      } catch (error) {
        // Fall through to error response.
      }
    }

    if (xhr && xhr.responseText && xhr.responseText.trim().length) {
      try {
        return JSON.parse(xhr.responseText);
      } catch (error) {
        // Fall through to error response.
      }
    }

    return {
      success: false,
      error: 'Erreur lors de la synchronisation des commandes.'
    };
  }

  buildFallbackResponse(orderIds) {
    return {
      success: true,
      message: 'Synchronisation reussie.',
      details: (orderIds || []).map((orderId) => ({ success: true, order_id: orderId }))
    };
  }
}
